import { render, staticRenderFns } from "./EditVersion.vue?vue&type=template&id=c6873642&scoped=true"
import script from "./EditVersion.vue?vue&type=script&lang=js"
export * from "./EditVersion.vue?vue&type=script&lang=js"
import style0 from "./EditVersion.vue?vue&type=style&index=0&id=c6873642&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6873642",
  null
  
)

export default component.exports